<template>
  <div v-if="initialized">
    <form method="#" action="#">
      <div class="row">
        <div class="card" style="text-align: center; padding: 50px;">
          <!-- <h1 v-if="user.data.name">Hi {{user.data.name}}!<br>Welcome to Authentic.net.</h1> -->
          <h1>Welcome to Authentic.net</h1>
          <p style="font-size: 1.5em;">
            Let's take 2 minutes to get you settled in. Provide your account details below.
          </p>
          <p v-if="userAuth.phoneNumber" class="text-success">DONE. Profile details completed.</p>
          <fieldset v-if="!userAuth.phoneNumber">
            <div class="form-group">
              <label>First Name</label>
              <input type="text" v-model="profile.user.data.firstName" class="form-control">
            </div>
            <div class="form-group">
              <label>Last Name</label>
              <input type="text" v-model="profile.user.data.lastName" class="form-control">
            </div>
            <div class="form-group">
              <label>Mobile Phone Number</label>
              <input type="text" v-model="profile.authUser.phoneNumber" class="form-control">
            </div>
            <div class="form-group">
              <label>Business Name</label>
              <input type="text" v-model="profile.account.data.businessName" class="form-control">
            </div>
            <button v-if="!profile.loading" class="btn btn-info btn-fill btn-wd" @click.prevent="saveProfile()">Submit</button>
            <button v-if="profile.loading" type="button" class="btn btn-wd btn-info" disabled="disabled">
              <span class="btn-label">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </span>
              Submit
            </button>
          </fieldset>
        </div>
      </div>
      <div class="row">
        <div class="card" style="text-align: center; padding: 50px;">
          <h2>1. Security for your products</h2>
          <p style="font-size: 1.5em;">
            Your private key is below. Please copy it and store it in a very safe place where it cannot be lost.
            Your unique-in-the-world Authentic.net product codes are encrypted and nobody, not even Authentic.net, will be able
            to decrypt them for you without this key. Normal Authentic.net operation does not require decrypting product
            codes, but should you need to export your codes in bulk in the future then they will only be useful with this key.
          </p>
          <p v-if="!userAuth.phoneNumber" class="text-danger">Please complete your account details first.</p>
          <div v-if="userAuth.phoneNumber">
            <p v-if="!account.data.privateKey" class="text-success">DONE. Private Key Deleted.</p>
            <fieldset v-if="account.data.privateKey">
              <div class="form-group">
                <label>Your Private Key</label>
                <p>{{account.data.privateKey}}</p>
              </div>
              <button class="btn btn-info btn-fill btn-wd" @click.prevent="deletePrivateKey()">I Saved My Private Key</button>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="card" style="text-align: center; padding: 50px;">
          <h2>2. Add your first brand</h2>
          <p style="font-size: 1.5em;">
            Please provide your brand name and logo. If you are a startup and you do not yet have an official brand name
            then provide whatever label you want to categorize your first product(s) under.
          </p>
          <p v-if="!userAuth.phoneNumber || account.data.privateKey" class="text-danger">Before adding your first brand please finish step 1.</p>
          <p v-if="userAuth.phoneNumber && !account.data.privateKey && brand.data" class="text-success">DONE. Brand added.</p>
          <div v-if="userAuth.phoneNumber && !account.data.privateKey && !brand.data">
            <fieldset>
              <div class="form-group">
                <label>Brand Name</label>
                <input type="text" v-model="newBrand.name" class="form-control">
              </div>
            </fieldset>
            <fieldset>
              <div class="form-group">
                <label>Logo (image file)</label>
                <input type="file" name="brandImageFile" ref="brandImageFile" accept="image/*" @change="selectBrandImageFile" />
                <input v-show="false" type="text" name="logoUrl"  class="form-control" />
                <p-progress :value="brandLogoUploadProgress" type="info"></p-progress>
              </div>
            </fieldset>
            <button v-if="!loading && !brand.loading" class="btn btn-info btn-fill btn-wd" @click.prevent="addBrand">Add Brand</button>
            <button v-if="loading || brand.loading" type="button" class="btn btn-wd btn-info" disabled="disabled">
              <span class="btn-label">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </span>
              Add Brand
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="card" style="text-align: center; padding: 50px;">
          <h2>3. Add your first product</h2>
          <p style="font-size: 1.5em;">
            Please provide your product name and image. We will then immediately create your first Authentic.net product code!
          </p>
          <p v-if="!brand.data" class="text-danger">Before adding your first product please finish step 2.</p>
          <p v-if="brand.data && product.data" class="text-success">DONE. Product added.</p>
          <div v-if="brand.data && !product.data">
            <fieldset>
              <div class="form-group">
                <label>Product Name</label>
                <input type="text" v-model="newProd.name" class="form-control">
              </div>
            </fieldset>
            <fieldset>
              <div class="form-group">
                <label>Product Image (image file)</label>
                <input type="file" name="prodImageFile" ref="prodImageFile" accept="image/*" @change="selectProdImageFile" />
                <input v-show="false" type="text" name="logoUrl"  class="form-control" />
                <p-progress :value="prodImageUploadProgress" type="info"></p-progress>
              </div>
            </fieldset>
            <button v-if="!loading && !product.loading" class="btn btn-info btn-fill btn-wd" @click.prevent="addProd">Add Product</button>
            <button v-if="loading || product.loading" type="button" class="btn btn-wd btn-info" disabled="disabled">
              <span class="btn-label">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </span>
              Add Product
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="card" style="text-align: center; padding: 50px;">
          <h2>Try validating your first Authentic.net product code!</h2>
          <p style="font-size: 1.5em;">
            The link below as well as the QR code display both contain your first Authentic.net product code.
            Click the link or scan the code below to initiate the product validation process.
            Once you get confirmation that your code is authentic you will be redirected back here.
          </p>
          <p v-if="!product.data" class="text-danger">Please finish step 3 to generate your first Authentic.net product code.</p>
          <div v-if="qrInitiated && !codeValue">
            <p>Generating Authentic.net product code...</p>
            <p-progress style="width: 50%; margin-left: auto; margin-right: auto;" :value="qrProgress" type="info"></p-progress>
          </div>
          <div v-if="product.data && codeValue">
            <p style="font-size: 1.5em; font-weight: bold;"><a :href="codeValue">Click Here</a></p>
            <p>-OR-</p>
            <p>Scan:</p>
            <qrcode v-if="!!qrValue" :value="qrValue" :options="{ size: 200 }"></qrcode>
            <p>
              *Under normal circumstances your unique Authentic.net product codes will be printed directly
              to labels using your Dymo printer, but we are displaying this one on screen so you can quickly test it.
            </p>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'
  import swal from 'sweetalert2'
  import PProgress from 'src/components/UIComponents/Progress.vue'
  import {mapFields} from 'vee-validate'
  import { EventBus } from '@/eventBus'

  export default {
    components: {
      PProgress
    },
    mixins: [toolboxMixin],
    computed: {
      ...mapFields(['brandName', 'productName'])
    },
    data () {
      return {
        initialized: false,
        loading: false,
        userAuth: {
          phoneNumber: null
        },
        user: {},
        profile: {
          loading: false,
          authUser: {
            email: '',
            phoneNumber: ''
          },
          user: {
            data: {
              firstName: '',
              lastName: ''
            }
          },
          account: {
            data: {
              businessName: ''
            }
          }
        },
        account: {
          data: null
        },
        newBrand: {
          logoUrl: '',
          name: ''
        },
        brandLogoUploadProgress: 0,
        brandId: '',
        brand: {
          loading: false,
          data: null
        },
        newProd: {
          name: '',
          imageUrl: ''
        },
        prodImageUploadProgress: 0,
        product: {
          loading: false,
          data: null
        },
        productId: '',
        codeValue: '',
        qrValue: '',
        modelValidations: {
          brandName: {
            required: true
          },
          productName: {
            required: true
          }
        },
        qrInitiated: false,
        qrProgress: 0
      }
    },
    methods: {
      async init () {
        this.getCurrentUser().then(user => {
          this.userAuth = {
            uid: user.uid,
            phoneNumber: user.phoneNumber,
            email: user.email
          }
          console.log('got user')
          console.log(this.user)
          if (this.userAuth.phoneNumber) {
            this.getAccountDetails()
          } else {
            this.initialized = true
          }
        })
      },
      getAccountDetails () {
        console.log('getting account details')
        this.getAuthDetails().then(authDetails => {
          console.log('heres what we got')
          console.log(authDetails)
          this.userAuth = authDetails.userAuth
          console.log('userAuth')
          console.log(this.userAuth)
          console.log(this.userAuth.phoneNumber)
          this.user = authDetails.user
          this.account = authDetails.account
          this.brand.accountId = this.user.accountId
          console.log(this.user)
          this.getExistingBrand()
          this.loading = false
          this.initialized = true
        }).catch(error => {
          console.log(error)
        })
      },
      getExistingBrand () {
        db.collection('brands').where('accountId', '==', this.user.data.accountId).limit(1).get()
        .then(qs => {
          qs.forEach(doc => {
            this.brandId = doc.id
            this.brand.id = doc.id
            this.brand.data = doc.data()
            this.listenForCode()
            this.getExistingProduct(doc.id)
          })
        })
      },
      getExistingProduct (brandId) {
        db.collection(`brands/${brandId}/products`).limit(1).get()
        .then(qs => {
          qs.forEach(doc => {
            this.productId = doc.id
            this.product.id = doc.id
            this.product.data = doc.data()
          })
          this.initialized = true
        })
        .catch(err => {
          this.initialized = true
          console.log(err)
        })
      },
      listenForCode () {
        console.log('listening')
        db.collection('authCodes').where('brandId', '==', this.brand.id)
        .onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            if (change.type === 'added') {
              let doc = change.doc
              this.qrProgress = 100
              this.code = {
                id: doc.id,
                codeValue: '0002' + doc.data().code
              }
              this.codeValue = '/authenticate?code=' + this.code.codeValue
              this.qrValue = 'https://appdev.authentic.net/authenticate?code=' + this.code.codeValue
              if (doc.data().qtyValidations > 0) {
                swal.fire({
                  title: `Congratulations!`,
                  text: 'Onboarding is complete. You will now be redirected to your Dashboard. Please select a plan and provide payment info to unlock your 30 day trial and unlock full access to your account.',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-success btn-fill',
                  type: 'success'
                })
                .then(() => {
                  this.finalizeOnboarding()
                })
                .catch(error => {
                  console.log(error)
                  this.finalizeOnboarding()
                })
              }
            }
            if (change.type === 'modified') {
              let doc = change.doc
              let data = doc.data()
              this.finalizeOnboarding()
            }
          })
        })
      },
      finalizeOnboarding () {
        db.collection('accounts').doc(this.account.id).update({ status: 'pending-plan' })
        .then(docRef => {
          EventBus.$emit('auth-refreshed')
          this.$router.replace({ name: 'Dashboard' })
        })
      },
      saveProfile () {
        this.profile.loading = true
        let data = this.profile
        data.authUser.phoneNumber = '+1' + this.profile.authUser.phoneNumber
        data.authUser.uid = this.userAuth.uid
        data.authUser.email = this.userAuth.email
        let setupAccount = firebase.functions().httpsCallable('setupAccount')
        setupAccount(data)
        .then(result => {
          if (result.data.success) {
            // document.location.reload()
            this.showNotify('Profile information saved. Please continue to Step 1.', 'success', 'Success')
            this.refreshCurrentUser()
            this.getAccountDetails()
          } else {
            swal.fire({
              title: 'Error',
              text: 'Sorry, there was an error saving your profile',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
            this.profile.loading = false
          }
        })
        .catch(err => {
          console.error(err.message)
          swal.fire({
            title: 'Error',
            text: 'Sorry, the following error took place: ' + err.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          this.profile.loading = false
        })
      },
      selectBrandImageFile () {
        let imageFile = this.$refs.brandImageFile.files[0]
        this.uploadBrandImageFile(imageFile)
      },
      uploadBrandImageFile (imageFile) {
        this.brand.loading = true

        var storageRef = firebase.storage().ref()
        var filename = this.$uuid.v4() + '.' + imageFile.name.split('.').pop()
        var uploadTask = storageRef.child(`brands/${filename}`).put(imageFile)

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          snapshot => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.brandLogoUploadProgress = progress
            console.log('Upload is ' + progress + '% done')
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log('Upload is paused')
                break
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log('Upload is running')
                break
            }
          }, error => {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            swal.fire({
              title: 'Error Uploading Image',
              text: 'Please try a different image and contact support if the problem persists',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            }).then(() => {
              this.brand.loading = false
            })
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break

              case 'storage/canceled':
                // User canceled the upload
                break

              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break
            }
          }, () => {
            // Upload completed successfully, now we can get the download URL
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              console.log('File available at', downloadURL)
              this.newBrand.logoUrl = downloadURL
              this.brand.loading = false
            })
          })
      },
      addBrand () {
        this.brand.loading = true
        let brand = {
          name: this.newBrand.name,
          logoUrl: this.newBrand.logoUrl,
          accountId: this.account.id,
          qtyValidations: 0,
          qtyRegistrations: 0
        }
        console.log(brand)
        db.collection('brands').add(brand).then(docRef => {
          this.brand = {
            id: docRef.id,
            data: {
              name: brand.name,
              logoUrl: brand.logoUrl
            }
          }
          this.brand.loading = false
          this.showNotify('Brand saved. Please continue to step 3.', 'success', 'Success')
        })
        .catch(err => {
          swal.fire({
            title: 'Error',
            text: err,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          this.loading = false
        })
      },
      selectProdImageFile () {
        let imageFile = this.$refs.prodImageFile.files[0]
        this.uploadProdImageFile(imageFile)
      },
      uploadProdImageFile (imageFile) {
        this.product.loading = true

        var storageRef = firebase.storage().ref()
        var filename = this.$uuid.v4() + '.' + imageFile.name.split('.').pop()
        var uploadTask = storageRef.child(`products/${filename}`).put(imageFile)

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          snapshot => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.prodImageUploadProgress = progress
            console.log('Upload is ' + progress + '% done')
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log('Upload is paused')
                break
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log('Upload is running')
                break
            }
          }, error => {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            swal.fire({
              title: 'Error Uploading Image',
              text: 'Please try a different image and contact support if the problem persists',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            }).then(() => {
              this.product.loading = false
            })
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object
                break

              case 'storage/canceled':
                // User canceled the upload
                break

              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse
                break
            }
          }, () => {
            // Upload completed successfully, now we can get the download URL
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              console.log('File available at', downloadURL)
              this.newProd.imageUrl = downloadURL
              this.product.loading = false
            })
          })
      },
      addProd () {
        this.product.loading = true
        let product = {
          name: this.newProd.name,
          imageUrl: this.newProd.imageUrl,
          brandId: this.brand.id,
          qtyValidations: 0,
          qtyRegistrations: 0
        }
        console.log(product)
        db.collection(`brands/${product.brandId}/products`).add(product).then(docRef => {
          this.product = {
            id: docRef.id,
            data: {
              name: product.name,
              imageUrl: product.imageUrl
            }
          }
          this.product.loading = false
          this.showNotify('Product saved. Please validate your first Authentic.net product code once it\'s ready', 'success', 'Success')
          this.makeAuthCode()
        })
        .catch(err => {
          swal.fire({
            title: 'Error',
            text: err,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          this.loading = false
        })
      },
      deletePrivateKey () {
        swal.fire({
          title: 'Are you sure?',
          text: `Did you actually save your private key? It will be removed from Authentic.net and you won't be able to revert this!`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Yes, my key is safe!',
          buttonsStyling: false
        }).then(() => {
          db.collection('accounts').doc(this.account.id).update({ privateKey: '' }).then(result => {
            this.account.data.privateKey = ''
            this.showNotify('Private key deleted. Please continue to Step 2.', 'success', 'Success')
          })
        })
      },
      makeAuthCode () {
        // this.model.products[this.productSelect.product_id] = true
        this.qrInitiated = true
        this.qrProgress = 33
        let batch = {
          status: 'Requested',
          qty: 1,
          qtyCreated: 0,
          accountId: this.account.id,
          productId: this.product.id,
          brandId: this.brand.id,
          retailerId: '',
          createdAt: firebase.firestore.FieldValue.serverTimestamp()
        }
        console.log(batch)
        db.collection(`brands/${this.accountData.activeBrand.id}/authCodeBatches`).add(batch).then(response => {
          this.qrProgress = 66
          this.listenForCode()
          this.loading = false
        })
        .catch(err => {
          swal.fire({
            title: 'Error',
            text: err,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          this.loading = false
        })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      }
    },
    // watch: {
    //   initialized (value) {
    //     if (this.initialized && this.brandId !== '' && this.productId !== '') {
    //       this.$router.replace({ name: 'Dashboard' })
    //     }
    //   }
    // },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Onboarding/Onboarding.vue